"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[861],{

/***/ 7082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(2097);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(8958);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(7500);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Breadcrumbs/Breadcrumbs.js + 3 modules
var Breadcrumbs = __webpack_require__(4489);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(1567);
;// CONCATENATED MODULE: ./src/components/BreadCrumbs/BreadCrumbs.tsx








var BreadCrumbs_Link = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Link/* Link */.r, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
function BreadCrumbs(props) {
    var breadcrumbs = props.breadcrumbs;
    var theme = (0,useTheme/* default */.Z)();
    var crumbRefs = react.useRef([]);
    var t = (0,useTranslation/* useTranslation */.$)([
        "common"
    ]).t;
    // Todo: Fix crumbRefs.current typescript problem.
    // @ts-ignore
    crumbRefs.current = breadcrumbs.map(function(crumb, index) {
        var _index;
        // @ts-ignore
        return (_index = crumbRefs.current[index]) !== null && _index !== void 0 ? _index : /*#__PURE__*/ react.createRef();
    });
    if (!(props === null || props === void 0 ? void 0 : props.hidden)) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumbs/* default */.Z, {
        "aria-label": "breadcrumb",
        sx: {
            margin: theme.spacing(2, 0)
        },
        children: breadcrumbs.map(function(crumb, index) {
            return breadcrumbs[breadcrumbs.length - 1] ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs_Link, {
                // @ts-ignore
                ref: crumbRefs.current[index],
                underline: "hover",
                color: "text.primary",
                href: crumb.path,
                "aria-current": "page",
                variant: "body2",
                children: crumb.name === "Home" ? t("home", "Home") : crumb.name
            }, index) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs_Link, {
                // @ts-ignore
                ref: crumbRefs.current[index],
                underline: "hover",
                color: "inherit",
                href: crumb.path,
                variant: "body2",
                children: crumb.name
            }, index);
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
}

;// CONCATENATED MODULE: ./src/components/BreadCrumbs/index.ts



/***/ }),

/***/ 9757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ DefaultView; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js + 2 modules
var Container = __webpack_require__(6336);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(9630);
// EXTERNAL MODULE: ./src/components/BreadCrumbs/index.ts + 1 modules
var BreadCrumbs = __webpack_require__(7082);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(2097);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(1225);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(8958);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(9072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(918);
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 122 modules
var react_markdown = __webpack_require__(9054);
;// CONCATENATED MODULE: ./src/components/DefaultContent/index.tsx










var DefaultContent_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
// @ts-ignore Todo: Complete type definitions for DefaultContent.
function DefaultContent(param) {
    var children = param.children, body = param.body;
    var theme = (0,useTheme/* default */.Z)();
    var md = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    var h1Ref = react.useRef(null);
    var h2Ref = react.useRef(null);
    var h3Ref = react.useRef(null);
    var h4Ref = react.useRef(null);
    var h5Ref = react.useRef(null);
    var h6Ref = react.useRef(null);
    var subtitle1Ref = react.useRef(null);
    var subtitle2Ref = react.useRef(null);
    var body1Ref = react.useRef(null);
    var body2Ref = react.useRef(null);
    var buttonRef = react.useRef(null);
    var captionRef = react.useRef(null);
    var overlineRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Paper/* default */.Z, {
        elevation: 1,
        sx: {
            padding: theme.spacing(md ? 4 : 2),
            marginBottom: theme.spacing(md ? 4 : 2)
        },
        children: [
            children,
            body ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_markdown/* ReactMarkdown */.D, {
                children: body
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "Primary"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 0,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.primary.light,
                                            padding: theme.spacing(2)
                                        },
                                        children: "light"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.primary.main,
                                            padding: theme.spacing(2)
                                        },
                                        children: "main"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.primary.dark,
                                            padding: theme.spacing(2)
                                        },
                                        children: "dark"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.primary.main,
                                            color: theme.palette.primary.contrastText,
                                            padding: theme.spacing(2)
                                        },
                                        children: "contrastText"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "Secondary"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 0,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.secondary.light,
                                            padding: theme.spacing(2)
                                        },
                                        children: "light"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.secondary.main,
                                            padding: theme.spacing(2)
                                        },
                                        children: "main"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.secondary.dark,
                                            padding: theme.spacing(2)
                                        },
                                        children: "dark"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.secondary.main,
                                            color: theme.palette.secondary.contrastText,
                                            padding: theme.spacing(2)
                                        },
                                        children: "contrastText"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "Grey"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 0,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["50"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "50"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["100"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "100"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["200"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "200"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["300"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "300"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["400"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "400"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["500"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "500"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["600"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "600"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["700"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "700"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["800"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "800"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["900"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "900"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["A100"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "A100"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["A200"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "A200"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["A400"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "A400"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["A700"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "A700"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "Text"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 0,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            color: theme.palette.text["primary"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "primary"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            color: theme.palette.text["secondary"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "secondary"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            color: theme.palette.text["disabled"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "disabled"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "H1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: h1Ref,
                                variant: "h1",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "H2"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: h2Ref,
                                variant: "h2",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "H3"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: h3Ref,
                                variant: "h3",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "H4"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: h4Ref,
                                variant: "h4",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "H5"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: h5Ref,
                                variant: "h5",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "H6"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: h6Ref,
                                variant: "h6",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "subtitle1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: subtitle1Ref,
                                variant: "subtitle1",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "subtitle2"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: subtitle2Ref,
                                variant: "subtitle2",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "body1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: body1Ref,
                                variant: "body1",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "body2"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: body2Ref,
                                variant: "body2",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "button"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: buttonRef,
                                variant: "button",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "caption"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: captionRef,
                                variant: "caption",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "overline"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: overlineRef,
                                variant: "overline",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/DefaultView/index.tsx






// import { useTranslation } from 'next-i18next';
// import { useTheme } from '@mui/material/styles';

// import { useAppContext } from '../../contexts/AppContext';

var DefaultView_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
/**
 * This component is used as fallback view in case no component for a page
 * is set during a BigBang site build.
 *
 * This component can be used as example "view" component within our NPM framework.
 *
 * @param props AllViewProps (don't use the AllViewProps type, use a specific one instead.)
 * @constructor
 */ function DefaultView(props) {
    var // global,
    pageContext = props.pageContext, title = props.title, body = props.body;
    var h1Ref = react.useRef(null);
    // const theme = useTheme();
    // const appContext = useAppContext();
    // const {
    //   componentOptions,
    // } = appContext.useConfig();
    // const {
    //   user,
    //   isLoading,
    //   isError
    // } = appContext.useUser();
    // The 'common' translations namespace is passed on server side (getStaticProps) already.
    // const { t } = useTranslation();
    // React.useEffect(() => {
    //   console.info({
    //     global,
    //     pageContext,
    //     title,
    //     body,
    //     appContext,
    //     componentOptions,
    //     collections,
    //     collection,
    //     game,
    //   });
    // }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // React.useEffect(() => {
    //   if (!user) return;
    //   console.info({ user });
    // }, [user]);
    // if (isLoading) return <div>loading...</div>
    // if (isError) return <div>failed to load</div>
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.Z, {
        maxWidth: "md",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs/* BreadCrumbs */.b, {
                breadcrumbs: pageContext.breadcrumbs
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent, {
                body: body,
                children: title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultView_Typography, {
                    ref: h1Ref,
                    component: "h1",
                    variant: "h1",
                    children: title
                })
            })
        ]
    });
}


/***/ }),

/***/ 7500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* unused harmony export NextLinkComposed */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6010);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1719);
/* harmony import */ var next_translate_routes_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3966);
/* harmony import */ var next_translate_routes_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material_Link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8346);
/* harmony import */ var _contexts_CursorContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5888);












// Add support for the sx prop for consistency with the other branches.
var Anchor = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)("a")({});
var NextLinkComposed = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function NextLinkComposed(props, ref) {
    var to = props.to, linkAs = props.linkAs, replace = props.replace, scroll = props.scroll, shallow = props.shallow, prefetch = props.prefetch, locale = props.locale, storybook = props.storybook, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(props, [
        "to",
        "linkAs",
        "replace",
        "scroll",
        "shallow",
        "prefetch",
        "locale",
        "storybook"
    ]);
    return storybook ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: to,
        prefetch: prefetch,
        as: linkAs,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        passHref: true,
        locale: locale,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Anchor, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            ref: ref
        }, other))
    }) : /* next-translate-routes/link is using the wrong Type for next/link. */ /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)((next_translate_routes_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: to,
        prefetch: prefetch,
        as: linkAs,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        passHref: true,
        locale: locale,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Anchor, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            ref: ref
        }, other))
    });
});
// A styled version of the Next.js Link component:
// https://nextjs.org/docs/api-reference/next/link
var Link = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Link(props, ref) {
    var _activeClassName = props.activeClassName, activeClassName = _activeClassName === void 0 ? "active" : _activeClassName, as = props.as, classNameProps = props.className, href = props.href, linkAsProp = props.linkAs, locale = props.locale, noLinkStyle = props.noLinkStyle, prefetch = props.prefetch, replace = props.replace, role = props.role, scroll = props.scroll, shallow = props.shallow, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(props, [
        "activeClassName",
        "as",
        "className",
        "href",
        "linkAs",
        "locale",
        "noLinkStyle",
        "prefetch",
        "replace",
        "role",
        "scroll",
        "shallow"
    ]);
    var enabled = (0,_contexts_CursorContext__WEBPACK_IMPORTED_MODULE_4__/* .useCursorContext */ .r)().enabled;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var storybook = router === null || router === void 0 ? void 0 : router.storybook;
    var pathname = typeof href === "string" ? href : href.pathname;
    var className = (0,clsx__WEBPACK_IMPORTED_MODULE_9__["default"])(classNameProps, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, activeClassName, router.pathname === pathname && activeClassName));
    var isExternal = typeof href === "string" && (href.indexOf("http") === 0 || href.indexOf("mailto:") === 0);
    if (isExternal) {
        if (noLinkStyle) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Anchor, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                className: className,
                href: enabled ? "#" : href,
                ref: ref
            }, other));
        }
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            className: className,
            href: enabled ? "#" : href,
            ref: ref
        }, other));
    }
    var linkAs = linkAsProp || as;
    var nextjsProps = {
        to: enabled ? "#" : href,
        linkAs: linkAs,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        prefetch: prefetch,
        locale: locale,
        storybook: storybook
    };
    if (noLinkStyle) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(NextLinkComposed, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            className: className,
            ref: ref
        }, nextjsProps, other));
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        component: NextLinkComposed,
        className: className,
        ref: ref
    }, nextjsProps, other));
});


/***/ }),

/***/ 8958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useHighlightHandlers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2097);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4794);







// Todo: Have a hard time setting the type for Component, as it can be Mui Typography or our own Link component.
var useHighlightHandlers = function(Component, props) {
    var enabledVariants = (0,_index__WEBPACK_IMPORTED_MODULE_1__/* .useHighlightContext */ .A)().enabledVariants;
    var forwardedRef = props.forwardedRef, variant = props.variant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "forwardedRef",
        "variant"
    ]);
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var element = null;
    // Todo: Not sure how to resolve this missing current ts warning.
    // @ts-ignore
    if (forwardedRef && (forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current)) {
        // Todo: Not sure how to resolve this missing current ts warning.
        // @ts-ignore
        element = forwardedRef.current;
    }
    if (element && variant && Array.isArray(enabledVariants)) {
        if (enabledVariants.includes(variant)) {
            element.style.outline = "2px dotted ".concat(theme.palette.info.main);
            element.style.outlineOffset = "-2px";
            element.style.position = "relative";
            if (!element.querySelector(".typographyBadge")) {
                var badge = document.createElement("div");
                badge.classList.add("typographyBadge");
                badge.style.position = "absolute";
                badge.style.top = theme.spacing(-0.5);
                badge.style.right = theme.spacing(-0.5);
                badge.style.backgroundColor = theme.palette.info.main;
                badge.style.borderRadius = "".concat(theme.shape.borderRadius, "px");
                badge.style.color = theme.palette.info.contrastText;
                badge.style.fontSize = "10px";
                badge.style.lineHeight = "10px";
                badge.style.padding = theme.spacing(0.5, 1);
                badge.style.boxShadow = theme.shadows[1];
                badge.style.textTransform = "capitalize";
                badge.innerText = [
                    "contained",
                    "text",
                    "outlined"
                ].includes(variant) ? "button" : variant;
                element.appendChild(badge);
            }
        } else {
            var ref;
            element.style.outline = "unset";
            (ref = element.querySelector(".typographyBadge")) === null || ref === void 0 ? void 0 : ref.remove();
        }
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        variant: variant,
        ref: forwardedRef
    }));
};


/***/ }),

/***/ 2176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ BaseLayout; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/layouts/DefaultNestedLayout/index.tsx

/**
 * This component is used as fallback nested layout in case no layout component for a page
 * is set during a BigBang site build.
 *
 * This layout can be used as example "NestedLayout" component within our NPM framework.
 *
 * @param props LayoutProps
 * @constructor
 */ function DefaultNestedLayout(props) {
    var children = props.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: children
    });
}

;// CONCATENATED MODULE: ./src/layouts/DefaultLayout/index.tsx



/**
 * Extend the page view component with this component through "Component.getLayout".
 * This component is used as higher order component within _app.tsx.
 * https://nextjs.org/docs/basic-features/layouts
 * @param props LayoutProps
 * @constructor
 */ function DefaultLayout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultNestedLayout, {
        pageContext: pageContext,
        children: children
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(7120);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(1225);
// EXTERNAL MODULE: ./src/utils/ads-request.ts
var ads_request = __webpack_require__(8505);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 4 modules
var AppContext = __webpack_require__(6242);
;// CONCATENATED MODULE: ./src/layouts/LayoutB/LayoutB.tsx










var AdvertisementSlot = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9918).then(__webpack_require__.bind(__webpack_require__, 9918)).then(function(mod) {
        return mod.AdvertisementSlot;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9918)
            ];
        }
    },
    ssr: false
});
var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eqs1sve0"
})(function() {
    return {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        height: "auto"
    };
});
var Sides = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eqs1sve1"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "none"
    }, theme.breakpoints.up(1200), {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        flexGrow: 0,
        flexWrap: "nowrap",
        height: "fit-content",
        justifyContent: "center",
        padding: theme.spacing(7, 2, 2)
    });
});
var AdvertisementSlotStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(AdvertisementSlot, {
    target: "eqs1sve2"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0],
        margin: theme.spacing(0, 0, 4)
    };
});
var LayoutB = function(props) {
    var children = props.children;
    var router = (0,next_router.useRouter)();
    var xlCustom = (0,useMediaQuery/* default */.Z)("(min-width:1560px)", {
        noSsr: true
    });
    var lgCustom = (0,useMediaQuery/* default */.Z)("(max-width:1559px) and (min-width:1280px)", {
        noSsr: true
    });
    var mdCustom = (0,useMediaQuery/* default */.Z)("(max-width:1279px) and (min-width:1200px)", {
        noSsr: true
    });
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), leftSize = ref[0], setLeftSize = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), rightSize = ref1[0], setRightSize = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), banners = ref2[0], setBanners = ref2[1];
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var componentOptions = appContext.useConfig().componentOptions;
    var layoutAdsElements = {
        "idhb-left-300": !componentOptions.component_layout_left_ads_disabled || false,
        "idhb-left-small-300": !componentOptions.component_layout_left_middle_ads_disabled || false,
        "idhb-right-300": !componentOptions.component_layout_right_ads_disabled || false,
        "idhb-right-small-300": !componentOptions.component_layout_right_middle_ads_disabled || false
    };
    var bannerConditions = [
        {
            key: "idhb-left-300",
            condition: function(size) {
                return size > 0;
            }
        },
        {
            key: "idhb-left-small-300",
            condition: function(size) {
                return size >= 300;
            }
        },
        {
            key: "idhb-right-300",
            condition: function(size) {
                return size > 0;
            }
        },
        {
            key: "idhb-right-small-300",
            condition: function(size) {
                return size >= 300;
            }
        }, 
    ];
    react.useEffect(function() {
        if (xlCustom) {
            setLeftSize(300);
            setRightSize(300);
        } else if (lgCustom) {
            setLeftSize(160);
            setRightSize(160);
        } else if (mdCustom) {
            setLeftSize(120);
            setRightSize(120);
        } else {
            setLeftSize(0);
            setRightSize(0);
        }
    }, [
        xlCustom,
        lgCustom,
        mdCustom
    ]);
    react.useEffect(function() {
        var updatedBanners = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = bannerConditions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = _step.value, key = _value.key, condition = _value.condition;
                var isElementEnabled = layoutAdsElements[key];
                if (isElementEnabled && condition(leftSize)) {
                    updatedBanners.push(key);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setBanners(updatedBanners);
    }, [
        leftSize,
        rightSize,
        componentOptions
    ]);
    react.useEffect(function() {
        if (banners.length > 0 && !componentOptions.component_ads_disabled) (0,ads_request/* adsRequest */.S)(banners);
    }, [
        banners
    ]);
    react.useEffect(function() {
        var events = router.events;
        var handleRouteChange = function() {
            (0,ads_request/* adsRequest */.S)(banners);
        };
        events.on("routeChangeComplete", handleRouteChange);
        events.on("hashChangeComplete", handleRouteChange);
        return function() {
            events.off("routeChangeComplete", handleRouteChange);
            events.off("hashChangeComplete", handleRouteChange);
        };
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Root, {
        children: [
            !componentOptions.component_ads_disabled && leftSize > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Sides, {
                children: [
                    !componentOptions.component_layout_left_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotStyled, {
                        slotIdentifier: "idhb-left-300",
                        variant: "".concat(leftSize, "x600"),
                        elevation: 1,
                        alignment: "right"
                    }),
                    leftSize >= 300 && !componentOptions.component_layout_left_middle_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotStyled, {
                        slotIdentifier: "idhb-left-small-300",
                        variant: "300x250",
                        alignment: "right",
                        elevation: 1
                    })
                ]
            }),
            children,
            !componentOptions.component_ads_disabled && leftSize > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Sides, {
                children: [
                    !componentOptions.component_layout_right_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotStyled, {
                        slotIdentifier: "idhb-right-300",
                        variant: "".concat(leftSize, "x600"),
                        alignment: "left",
                        elevation: 1
                    }),
                    leftSize >= 300 && !componentOptions.component_layout_right_middle_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotStyled, {
                        slotIdentifier: "idhb-right-small-300",
                        variant: "300x250",
                        alignment: "left",
                        elevation: 1
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/layouts/LayoutB/index.ts


;// CONCATENATED MODULE: ./src/generated/game/layout.tsx



function Layout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutB, {
        pageContext: pageContext,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/layouts/BaseLayout/index.tsx




// IMPORTANT: The page.name in the import and switch case must match with the pageType set in the BaseLayoutProps definition!

var NavigationBar = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(6008), __webpack_require__.e(7622)]).then(__webpack_require__.bind(__webpack_require__, 7622)).then(function(mod) {
        return mod.NavigationBarA;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7622)
            ];
        }
    },
    ssr: true
});
var FooterBar = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(3056)]).then(__webpack_require__.bind(__webpack_require__, 3056)).then(function(mod) {
        return mod.FooterBarA;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3056)
            ];
        }
    },
    ssr: true
});
function BaseLayout(props) {
    var children = props.children, pageType = props.pageType, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBar, {}),
            function() {
                switch(pageType){
                    case "game":
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout, {
                            pageContext: pageContext,
                            children: children
                        });
                    default:
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultLayout, {
                            pageContext: pageContext,
                            children: children
                        });
                }
            }(),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterBar, {})
        ]
    });
}


/***/ }),

/***/ 8505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ adsRequest; }
/* harmony export */ });
var adsRequest = function(banners) {
    if (banners.length >= 1) {
        var ref;
        window.idhb = (window === null || window === void 0 ? void 0 : window.idhb) || {};
        window.idhb.que = ((ref = window.idhb) === null || ref === void 0 ? void 0 : ref.que) || [];
        window.idhb.que.push(function() {
            console.info("[hl]", banners);
            window.idhb.requestAds({
                // slotIds is optional. If not specified, ads for all configured slots on the page will be requested
                slotIds: banners
            });
        });
    }
};


/***/ })

}]);